/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  /*Para minificar o arquivo rode
      gulp watchJs --fn=custom --src=catalog/view/theme/laroche/javascript
  */

  if ($('.page-product-category').length > 0 || $('.page-product-search').length > 0) {
    toggleNewFilter();
  }
  function toggleNewFilter() {
    var container = $('.filterForm');
    if (container.length === 0) return;
    $('#column-left').addClass("has-filter-side");
    var filterGroups = ['.filter-price-container', '.filters.filter-option-container', '.filters.filter-custom-container'];
    var svg = "\n        <svg class=\"cat-toggle-icon\" width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t<path d=\"M7.00003 8C6.91645 8.00009 6.83368 7.98288 6.75647 7.94936C6.67926 7.91584 6.60914 7.86667 6.55012 7.80467L0.186494 1.13804C-0.0621647 0.877537 -0.0621647 0.455706 0.186494 0.195374C0.435153 -0.064958 0.837811 -0.0651246 1.08631 0.195374L7.00003 6.39067L12.9137 0.195374C13.1624 -0.0651246 13.5651 -0.0651246 13.8136 0.195374C14.0621 0.455873 14.0622 0.877703 13.8136 1.13804L7.44994 7.80467C7.39092 7.86667 7.32079 7.91584 7.24359 7.94936C7.16638 7.98288 7.08361 8.00009 7.00003 8Z\" fill=\"black\"/>\n\t\t</svg>";
    var category = $('.filters-new.filters-new-category');
    var children = container.children();
    var categoryTitle = category.find('.accordion-toggle.collapsed');
    category.addClass('filters');
    categoryTitle.addClass('filter-title').append(svg);
    category.insertBefore(children.eq(-2));
    if ($(window).width() < 1199) {
      $('.filter-side .buttons').prependTo('.filter-side .filterForm');
    }
    filterGroups.forEach(function (selector) {
      $(selector).each(function () {
        var group = $(this);
        var title = group.find('.filter-title');
        var list = group.find('ul, .range_inputs, #slider-range, .range_values');
        title.append(svg);
        title.on('click', function () {
          var isOpen = group.hasClass('filter-open');
          if (isOpen) {
            group.removeClass('filter-open');
            list.slideUp(300);
          } else {
            group.addClass('filter-open');
            list.slideDown(300);
          }
        });
        list.hide();
      });
    });
  }
});

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ })()
;